import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Get saved language from localStorage or default to 'en'
        return localStorage.getItem('language') || 'en';
    });

    const changeLanguage = (newLanguage) => {
        if (newLanguage !== language) {
            localStorage.setItem('language', newLanguage);
            setLanguage(newLanguage);
            // Reload the page to apply all translations
            window.location.reload();
        }
    };

    useEffect(() => {
        // Ensure HTML lang attribute matches current language
        document.documentElement.lang = language;
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
